/**
 * Supported UI languages. Adding a new language:
 *  1. Add an entry here (code + native name).
 *  2. Create locales/<code>/*.json files — copy from en/ as starting point.
 *  3. Import the files in i18n/index.ts resources block.
 */

export interface LanguageDef {
  code: string;
  /** Native name shown in the switcher. */
  native: string;
}

export const LANGUAGES: LanguageDef[] = [
  { code: "en", native: "english" },
  { code: "tr", native: "türkçe" },
  { code: "az", native: "azərbaycan" },
  { code: "be", native: "беларуская" },
  { code: "uk", native: "українська" },
  { code: "kk", native: "қазақша" },
  { code: "ky", native: "кыргызча" },
  { code: "ru", native: "русский" },
];

export const SUPPORTED_CODES = LANGUAGES.map((l) => l.code);
export const FALLBACK_LANGUAGE = "ru";
export const STORAGE_KEY = "lovestoria:lang";

/** Country code → preferred UI language. Anything not listed falls back to en. */
export const COUNTRY_TO_LANG: Record<string, string> = {
  RU: "ru",
  KZ: "kk",
  KG: "ky",
  BY: "be",
  UA: "uk",
  TR: "tr",
  AZ: "az",
};
